import {
  DataTableFilterMeta,
  DataTableFilterMetaData,
} from "primevue/datatable"
import { FilterMatchMode, FilterOperator } from "primevue/api"
import { ref } from "vue"

export default function tabelaProfissionais() {
  const filtrosTabelaProfissionais = ref<DataTableFilterMeta | undefined>({
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    codigo: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    categoria: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.IN },
      ] as DataTableFilterMetaData[],
    },
    usuarios_responsaveis: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.IN },
      ] as DataTableFilterMetaData[],
    },
  })

  return {
    filtrosTabelaProfissionais,
  }
}
